<ng-container *ngFor="let menu of menus">
  <div *ngIf="menu?.title"
       class="sidenav-menu-title">{{ menu?.title }}</div>
  <mat-accordion [displayMode]="'flat'">
    <ng-container *ngFor="let link of menu?.routers">
      <app-sidenav-menu [link]="link"
                        (linkClose)="handleClick($event)"
                        [collapse]="myCollapse">
      </app-sidenav-menu>
    </ng-container>
  </mat-accordion>
</ng-container>
